import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { PaymFormEnum } from "app/models/policy/detail/cancel-policy/PaymForm";

export function BankAccountValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (
      control.root.get('refunding.paymForm') != null &&
      control.root.get('refunding.paymForm').value == PaymFormEnum.BANKACCOUNT &&
      control.root.get('refunding.paymFormOptions.bankAccount.account').value == null &&
      control.root.get('refunding.paymFormOptions.bankAccount.customBankAccount').value == null
    ) {
      return { required: true }
    }
    return null;
  }
}

export function PaymFormValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {

    if (
      control.root.get('refunding.paymForm') != null &&
      control.root.get('refunding.paymForm').value == PaymFormEnum.BANKACCOUNT &&
      control.root.get('refunding.paymFormOptions.bankAccount.account').value == null &&
      control.root.get('refunding.paymFormOptions.bankAccount.customBankAccount').value == null
    ) {
      return { required: true }
    }
    return null;
  }
}
